import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeMobile from '../views/HomeMobile.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeMobile',
    component: HomeMobile
  }, {
    path: '/game/:id',
    name: 'GameMobile',
    component: () => import('../views/GameMobile.vue')
  }, {
    path: '/ys',
    name: 'YinSiMobile',
    component: () => import('../views/YinSiMobile.vue')
  }, {
    path: '/xy',
    name: 'XieYiMobile',
    component: () => import('../views/XieYiMobile.vue')
  }, {
    path: '/jz',
    name: 'XieYiMobile',
    component: () => import('../views/JiaZhangMobile.vue')
  }, {
    path: '/service',
    name: 'ServiceMobile',
    component: () => import('../views/ServiceMobile.vue')
  }, {
    path: '/us',
    name: 'UsMobile',
    component: () => import('../views/UsMobile.vue')
  }, {
    path: '/iosd',
    name: 'IosDownMobile',
    component: () => import('../views/IosDownMobile.vue')
  }, {
    path: '/iosdpriv',
    name: 'IosPrivDownMobile',
    component: () => import('../views/IosPrivDownMobile.vue')
  }, {
    path: '/hd_ganen/iosd',
    name: 'IosDownMobile',
    component: () => import('../views/IosDownMobile.vue')
  }, {
    path: '/hd1',
    name: 'HuoDong1Mobile',
    component: () => import('../views/HuoDong1Mobile.vue')
  }, {
    path: '/hd_ganen',
    name: 'HuoDongGanenMobile',
    component: () => import('../views/hd/HuoDongGanenMobile.vue')
  }, {
    path: '*',
    component: HomeMobile
  }
  // , {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
